import { useApiQuery } from '../useApiQuery';
import { acquisitionChannelKeys } from '@/lib/queryKeys';
import { acquisitionChannelEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { AcquisitionChannel } from '@/types/acquisitionChannel';

export function useAcquisitionChannels(options: { enabled?: boolean } = {}) {
  return useApiQuery<AcquisitionChannel[]>({
    queryKey: acquisitionChannelKeys.all(),
    queryFn: () =>
      apiGet<AcquisitionChannel[]>(operationsClient, acquisitionChannelEndpoints.list()),
    enabled: options.enabled ?? true,
    showErrorToast: false,
  });
}
